import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";




const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID

};


const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

//document.cookie = "user=JohnDoe; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; Secure; SameSite=Lax";

// Check if analytics is supported
isSupported().then(supported => {
  if (supported) {
   // const analytics = getAnalytics(firebaseApp);
    //console.log("Firebase Analytics initialized");
  } else {
    console.log("Firebase Analytics is not supported in this environment.");
  }
}).catch(error => {
  console.error("Error checking Firebase Analytics support:", error);
});


export { firebaseApp, analytics };
